import jsonLogic from "json-logic-js";

import filter from "lodash/filter";
import find from "lodash/find";
import get from "lodash/get";
import head from "lodash/head";

export const evalVersion = (survey, branchName, context) => {
  const branch = find(get(survey, 'branches', []), { name: branchName });
  const versions = get(branch, 'versions', []);

  // Filter out versions evaluating to true according to their logic
  const filtered = filter(versions, version => jsonLogic.apply(get(version, 'logic', true), context));

  // Return first version from the filtered list
  const version = head(filtered);

  return version;
};

export default { evalVersion };
